export const stringHasValue = (val = '') =>
  val && val !== null && val !== undefined && typeof val === 'string' && val.trim() !== '';

export const browserDetect = {
  get isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  },
  get isEdge() {
    return window.navigator.userAgent.indexOf('Edge') > -1;
  }
};

import _ from 'lodash';
export const getQueryParamsAsString = params =>
  !_.isEmpty(params) ? `?${_.map(params, (param, key) => `${key}=${param}`).join('&')}` : '';

/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 * From: https://stackoverflow.com/a/14731922/1978835
 *
 * @param {Number} srcWidth width of source image
 * @param {Number} srcHeight height of source image
 * @param {Number} maxWidth maximum available width
 * @param {Number} maxHeight maximum available height
 * @return {Object} { width, height }
 */
export const calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth, maxHeight) => {
  const scale = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return {
    scale,
    width: srcWidth * scale,
    height: srcHeight * scale
  };
};

/**
 * @description keeps track of the last N urls visited by the client
 */
class navHistory {
  data;
  maxLength = 5;

  constructor() {
    this.data = [];
  }

  add = (item, isRefresh) => {
    item = encodeURI(item);
    if (this.first === item && !isRefresh) return;
    if (this.size > this.maxLength - 1) this.remove();
    this.data.unshift(item);
  };

  remove = () => {
    this.data.pop();
  };

  get first() {
    return this.data[0];
  }

  get referrerUrl() {
    return this.size === 1 ? this.first : this.data[1];
  }

  get size() {
    return this.data.length;
  }
}

export const navigationTracking = new navHistory();
